unit unit_Mitteilungen;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.WebCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, strutils;

type
  TMitteilungen = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    xdsMitteilungen: TXDataWebDataSet;
    xdsMitteilungenMSGBoardID: TXDataWebEntityField;
    xdsMitteilungenToPersonalnummer: TXDataWebEntityField;
    xdsMitteilungenMSGBoardSubID: TStringField;
    xdsMitteilungenToNachname: TStringField;
    xdsMitteilungenToVorname: TStringField;
    xdsMitteilungenDatumGelesen: TDateTimeField;
    xdsMitteilungenDatumErledigt: TDateTimeField;
    xdsMitteilungenMSGBoardIDFromPersonalnummer: TXDataWebEntityField;
    xdsMitteilungenMSGBoardIDID: TStringField;
    xdsMitteilungenMSGBoardIDDatum: TDateTimeField;
    xdsMitteilungenMSGBoardIDFromNachname: TStringField;
    xdsMitteilungenMSGBoardIDFromVorname: TStringField;
    xdsMitteilungenMSGBoardIDBetreff: TStringField;
    xdsMitteilungenMSGBoardIDNotiz: TStringField;
    btnzurueck: TButton;
    btnGesendete: TButton;
    btnErhaltene: TButton;
    btnNeueMitteilung: TButton;
    btnErhalteneUngefiltert: TButton;
    xdsMitteilungenToPersonalnummerPersonalnummer: TIntegerField;
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer: TIntegerField;
    xdsMitteilungenMSGBoardIDUrsprung: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsMitteilungenAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnGesendeteClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnErhalteneClick(Sender: TObject);
    procedure btnNeueMitteilungClick(Sender: TObject);
    procedure btnErhalteneUngefiltertClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    EinzelCard:THTMLDiv;
    procedure EinzelCardclick(Sender:TObject);
    procedure MitteilungenLaden;
  protected procedure LoadDFMValues; override; end;

var
  Mitteilungen: TMitteilungen;
  MSGModus:integer;
  //0 Eingang ungelesen/unbearbeitet ausgeschlossen
  //1 Eingang alle 100
  //2 Ausgang alle 100
implementation
   uses unit1, unit2, unit_EinzelMitteilung, unit_NeueMitteilung;
{$R *.dfm}

procedure TMitteilungen.MitteilungenLaden;
begin
  xdsMitteilungen.Close;
  if msgmodus=0 then xdsMitteilungen.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=(ToPersonalnummer eq '+Benutzerpersonalnummer+') AND (DatumErledigt eq null OR DatumGelesen eq null)&$orderby=MSGBoardID/Datum DESC';
  if msgmodus=1 then xdsMitteilungen.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=(ToPersonalnummer eq '+Benutzerpersonalnummer+') &$orderby=MSGBoardID/Datum DESC';
  if msgmodus=2 then xdsMitteilungen.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=(MSGBoardID/FromPersonalnummer eq '+Benutzerpersonalnummer+') &$orderby=MSGBoardID/Datum DESC';
  xdsMitteilungen.Load;
end;

procedure TMitteilungen.btnErhalteneClick(Sender: TObject);
begin
  msgmodus:=0;
  MitteilungenLaden;
end;

procedure TMitteilungen.btnErhalteneUngefiltertClick(Sender: TObject);
begin
  msgmodus:=1;
  MitteilungenLaden;
end;

procedure TMitteilungen.btnGesendeteClick(Sender: TObject);
begin
  msgmodus:=2;
  MitteilungenLaden;
end;

procedure TMitteilungen.btnNeueMitteilungClick(Sender: TObject);
var
  LFrm:TNeueMitteilung;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TNeueMitteilung;
    begin
      LForm:=(AForm as TNeueMitteilung);

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsMitteilungen.load;
    end;

  begin
  Container3.HTML.text:='';
  msgmodus:=2;
  xdsMitteilungen.Close;
  xdsMitteilungen.QueryString:='$expand=MSGBoardID, ToPersonalnummer, MSGBoardID/FromPersonalnummer&$filter=(MSGBoardID/FromPersonalnummer eq '+Benutzerpersonalnummer+') &$orderby=MSGBoardID/Datum DESC';
  LFrm:=TNeueMitteilung.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;




procedure TMitteilungen.btnzurueckClick(Sender: TObject);
begin
  xdsMitteilungen.Close;
  self.close;
end;


procedure TMitteilungen.EinzelCardclick(Sender:TObject);
var
  EinzelMitteilung:TEinzelMitteilung;
  MyMerkerMitteilung:string;
  MyMerkerMitteilungEdit:string;
begin
  myMerkerMitteilung:=(sender as THTMLDiv).hint;
  myMerkerMitteilungEdit:=(sender as THTMLDiv).role;
  Container3.HTML.text:='';
  EinzelMitteilung := TEinzelMitteilung.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelMitteilung).MerkerMitteilung:=myMerkerMitteilung;
      (AForm as TEinzelMitteilung).MerkerMitteilungEdit:=myMerkerMitteilungEdit;
      (AForm as TEinzelMitteilung).ArtMitteilung:=MSGModus;
    end
    );

  EinzelMitteilung.ShowModal(procedure(AValue: TModalResult)
    begin
      xdsMitteilungen.Close;
      xdsMitteilungen.load;
    end
    );
end;

procedure TMitteilungen.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  action:=cafree;
end;

procedure TMitteilungen.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  MSGModus:=0;
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Mitteilungen</h5></nav>';
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  MitteilungenLaden;
end;

procedure TMitteilungen.xdsMitteilungenAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Mitteilungen (erhaltene)</h5></nav>';
  if MSGModus=2 then Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Mitteilungen (gesendete)</h5></nav>';
  myelement:=container1.ElementHandle;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;

  btnzurueck.ParentElement:=myelement;
  btnErhaltene.ParentElement:=myelement;
  btnErhalteneUngefiltert.ParentElement:=myelement;
  btnGesendete.ParentElement:=myelement;
  btnNeueMitteilung.ParentElement:=myelement;
  container3.HTML.Text:='';
  btnErhaltene.Visible:=true;
  btnErhalteneUngefiltert.Visible:=true;
  btnGesendete.Visible:=true;
  if MSGModus=0 then btnErhaltene.Visible:=false;
  if MSGModus=1 then btnErhalteneUngefiltert.Visible:=false;
  if MSGModus=2 then btnGesendete.Visible:=false;
  xdsMitteilungen.First;
  while not xdsmitteilungen.eof do
  begin
    if (xdsMitteilungenDatumGelesen.IsNull) OR (xdsMitteilungenDatumErledigt.IsNull) then
    begin
    Einzelkarte:='<div class="card-header" style="background-color: #FFFF80"><h5>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsMitteilungenMSGBoardIDDatum.asdatetime)+' - ' +xdsMitteilungenMSGBoardIDBetreff.asstring+'</h5></div>';
    end
    else
    begin
    Einzelkarte:='<div class="card-header"><h5>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsMitteilungenMSGBoardIDDatum.asdatetime)+' - ' +xdsMitteilungenMSGBoardIDBetreff.asstring+'</h5></div>';
    end;
    if length(xdsMitteilungenMSGBoardIDNotiz.asstring)>60 then
    begin
      Einzelkarte:=Einzelkarte+'<div class="card-body "><h6>'+leftstr(xdsMitteilungenMSGBoardIDNotiz.asstring, 60)+' ...</h6>';
    end
    else
    begin
      Einzelkarte:=Einzelkarte+'<div class="card-body "><h6>'+xdsMitteilungenMSGBoardIDNotiz.asstring+'</h6>';
    end;
    if MSGModus<2 then Einzelkarte:=Einzelkarte+'<i> von: '+xdsMitteilungenMSGBoardIDFromNachname.asstring+', '+xdsMitteilungenMSGBoardIDFromVorname.asstring+' ('+xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.asstring+')</i><br>';
    if MSGModus=2 then Einzelkarte:=Einzelkarte+'<i> an:  '+xdsMitteilungenToNachname.asstring+', '+xdsMitteilungenToVorname.asstring+' ('+xdsMitteilungenToPersonalnummerPersonalnummer.asstring+')</i><br>';
    if not xdsMitteilungenDatumGelesen.IsNull then
    begin
      Einzelkarte:=Einzelkarte+'<i> gelesen:  '+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsMitteilungenDatumGelesen.asdatetime)+'</i><br>';
    end
    else
    begin
      Einzelkarte:=Einzelkarte+'<i> noch nicht gelesen</i><br>';
    end;
    if not xdsMitteilungenDatumErledigt.IsNull then
    begin
      Einzelkarte:=Einzelkarte+'<i> erledigt: '+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsMitteilungenDatumErledigt.asdatetime)+'</i><br>';
    end
    else
    begin
      Einzelkarte:=Einzelkarte+'<i> noch nicht erledigt</i><br>';
    end;

    Einzelkarte:=Einzelkarte+'</div>';
    myelement:=Container3.ElementHandle;
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.WidthStyle:=ssPercent;
    EinzelCard.Role:=xdsMitteilungenMSGBoardSubID.asstring;
    if (xdsMitteilungenMSGBoardIDUrsprung.asstring<>'') AND (leftstr(xdsMitteilungenMSGBoardIDUrsprung.asstring,5)<>'00000') then
    begin
      EinzelCard.hint:=xdsMitteilungenMSGBoardIDUrsprung.asstring;
    end
    else
    begin
      EinzelCard.hint:=xdsMitteilungenMSGBoardIDID.asstring;
    end;

    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card m-1 border-info';
    EinzelCard.OnClick:=@EinzelCardClick;
    EinzelCard.ParentElement:=myelement;
    xdsmitteilungen.Next;

  end;
end;

procedure TMitteilungen.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnGesendete := TButton.Create(Self);
  btnErhaltene := TButton.Create(Self);
  btnNeueMitteilung := TButton.Create(Self);
  btnErhalteneUngefiltert := TButton.Create(Self);
  xdsMitteilungen := TXDataWebDataSet.Create(Self);
  xdsMitteilungenMSGBoardID := TXDataWebEntityField.Create(Self);
  xdsMitteilungenToPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungenMSGBoardSubID := TStringField.Create(Self);
  xdsMitteilungenToNachname := TStringField.Create(Self);
  xdsMitteilungenToVorname := TStringField.Create(Self);
  xdsMitteilungenDatumGelesen := TDateTimeField.Create(Self);
  xdsMitteilungenDatumErledigt := TDateTimeField.Create(Self);
  xdsMitteilungenMSGBoardIDFromPersonalnummer := TXDataWebEntityField.Create(Self);
  xdsMitteilungenMSGBoardIDID := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDDatum := TDateTimeField.Create(Self);
  xdsMitteilungenMSGBoardIDFromNachname := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDFromVorname := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDBetreff := TStringField.Create(Self);
  xdsMitteilungenMSGBoardIDNotiz := TStringField.Create(Self);
  xdsMitteilungenToPersonalnummerPersonalnummer := TIntegerField.Create(Self);
  xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer := TIntegerField.Create(Self);
  xdsMitteilungenMSGBoardIDUrsprung := TStringField.Create(Self);

  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnGesendete.BeforeLoadDFMValues;
  btnErhaltene.BeforeLoadDFMValues;
  btnNeueMitteilung.BeforeLoadDFMValues;
  btnErhalteneUngefiltert.BeforeLoadDFMValues;
  xdsMitteilungen.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardID.BeforeLoadDFMValues;
  xdsMitteilungenToPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardSubID.BeforeLoadDFMValues;
  xdsMitteilungenToNachname.BeforeLoadDFMValues;
  xdsMitteilungenToVorname.BeforeLoadDFMValues;
  xdsMitteilungenDatumGelesen.BeforeLoadDFMValues;
  xdsMitteilungenDatumErledigt.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDID.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDDatum.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromNachname.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromVorname.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDBetreff.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDNotiz.BeforeLoadDFMValues;
  xdsMitteilungenToPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.BeforeLoadDFMValues;
  xdsMitteilungenMSGBoardIDUrsprung.BeforeLoadDFMValues;
  try
    Name := 'Mitteilungen';
    Width := 219;
    Height := 304;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 67;
    btnzurueck.Top := 141;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnGesendete.SetParentComponent(Self);
    btnGesendete.Name := 'btnGesendete';
    btnGesendete.Left := 67;
    btnGesendete.Top := 172;
    btnGesendete.Width := 96;
    btnGesendete.Height := 25;
    btnGesendete.Caption := 'Gesendete (max 100)';
    btnGesendete.ChildOrder := 4;
    btnGesendete.ElementClassName := 'btn btn-info m-1 text-left';
    btnGesendete.ElementFont := efCSS;
    btnGesendete.ElementPosition := epIgnore;
    btnGesendete.HeightStyle := ssAuto;
    btnGesendete.HeightPercent := 100.000000000000000000;
    btnGesendete.WidthStyle := ssAuto;
    btnGesendete.WidthPercent := 100.000000000000000000;
    SetEvent(btnGesendete, Self, 'OnClick', 'btnGesendeteClick');
    btnErhaltene.SetParentComponent(Self);
    btnErhaltene.Name := 'btnErhaltene';
    btnErhaltene.Left := 67;
    btnErhaltene.Top := 203;
    btnErhaltene.Width := 96;
    btnErhaltene.Height := 25;
    btnErhaltene.Caption := 'Unbearbeitete';
    btnErhaltene.ChildOrder := 4;
    btnErhaltene.ElementClassName := 'btn btn-info m-1 text-left';
    btnErhaltene.ElementFont := efCSS;
    btnErhaltene.ElementPosition := epIgnore;
    btnErhaltene.HeightStyle := ssAuto;
    btnErhaltene.HeightPercent := 100.000000000000000000;
    btnErhaltene.WidthStyle := ssAuto;
    btnErhaltene.WidthPercent := 100.000000000000000000;
    SetEvent(btnErhaltene, Self, 'OnClick', 'btnErhalteneClick');
    btnNeueMitteilung.SetParentComponent(Self);
    btnNeueMitteilung.Name := 'btnNeueMitteilung';
    btnNeueMitteilung.Left := 67;
    btnNeueMitteilung.Top := 231;
    btnNeueMitteilung.Width := 96;
    btnNeueMitteilung.Height := 25;
    btnNeueMitteilung.Caption := '+ Neue Mitteilung';
    btnNeueMitteilung.ChildOrder := 4;
    btnNeueMitteilung.ElementClassName := 'btn btn-info m-1 text-left';
    btnNeueMitteilung.ElementFont := efCSS;
    btnNeueMitteilung.ElementPosition := epIgnore;
    btnNeueMitteilung.HeightStyle := ssAuto;
    btnNeueMitteilung.HeightPercent := 100.000000000000000000;
    btnNeueMitteilung.WidthStyle := ssAuto;
    btnNeueMitteilung.WidthPercent := 100.000000000000000000;
    SetEvent(btnNeueMitteilung, Self, 'OnClick', 'btnNeueMitteilungClick');
    btnErhalteneUngefiltert.SetParentComponent(Self);
    btnErhalteneUngefiltert.Name := 'btnErhalteneUngefiltert';
    btnErhalteneUngefiltert.Left := 67;
    btnErhalteneUngefiltert.Top := 262;
    btnErhalteneUngefiltert.Width := 96;
    btnErhalteneUngefiltert.Height := 25;
    btnErhalteneUngefiltert.Caption := 'Erhaltene (max 100)';
    btnErhalteneUngefiltert.ChildOrder := 4;
    btnErhalteneUngefiltert.ElementClassName := 'btn btn-info m-1 text-left';
    btnErhalteneUngefiltert.ElementFont := efCSS;
    btnErhalteneUngefiltert.ElementPosition := epIgnore;
    btnErhalteneUngefiltert.HeightStyle := ssAuto;
    btnErhalteneUngefiltert.HeightPercent := 100.000000000000000000;
    btnErhalteneUngefiltert.WidthStyle := ssAuto;
    btnErhalteneUngefiltert.WidthPercent := 100.000000000000000000;
    SetEvent(btnErhalteneUngefiltert, Self, 'OnClick', 'btnErhalteneUngefiltertClick');
    xdsMitteilungen.SetParentComponent(Self);
    xdsMitteilungen.Name := 'xdsMitteilungen';
    xdsMitteilungen.AfterOpen := xdsMitteilungenAfterOpen;
    xdsMitteilungen.EntitySetName := 'MSGBoardSub';
    xdsMitteilungen.Connection := DM2.XDataWebConnection1;
    xdsMitteilungen.SubpropsDepth := 2;
    xdsMitteilungen.QueryString := '$expand=MSGBoardID, PersonalnummerTo';
    xdsMitteilungen.QueryTop := 100;
    xdsMitteilungen.Left := 21;
    xdsMitteilungen.Top := 157;
    xdsMitteilungenMSGBoardID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardID.Name := 'xdsMitteilungenMSGBoardID';
    xdsMitteilungenMSGBoardID.FieldName := 'MSGBoardID';
    xdsMitteilungenToPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToPersonalnummer.Name := 'xdsMitteilungenToPersonalnummer';
    xdsMitteilungenToPersonalnummer.FieldName := 'ToPersonalnummer';
    xdsMitteilungenMSGBoardSubID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardSubID.Name := 'xdsMitteilungenMSGBoardSubID';
    xdsMitteilungenMSGBoardSubID.FieldName := 'MSGBoardSubID';
    xdsMitteilungenMSGBoardSubID.Required := True;
    xdsMitteilungenMSGBoardSubID.Size := 38;
    xdsMitteilungenToNachname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToNachname.Name := 'xdsMitteilungenToNachname';
    xdsMitteilungenToNachname.FieldName := 'ToNachname';
    xdsMitteilungenToNachname.Size := 40;
    xdsMitteilungenToVorname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToVorname.Name := 'xdsMitteilungenToVorname';
    xdsMitteilungenToVorname.FieldName := 'ToVorname';
    xdsMitteilungenToVorname.Size := 40;
    xdsMitteilungenDatumGelesen.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenDatumGelesen.Name := 'xdsMitteilungenDatumGelesen';
    xdsMitteilungenDatumGelesen.FieldName := 'DatumGelesen';
    xdsMitteilungenDatumErledigt.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenDatumErledigt.Name := 'xdsMitteilungenDatumErledigt';
    xdsMitteilungenDatumErledigt.FieldName := 'DatumErledigt';
    xdsMitteilungenMSGBoardIDFromPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromPersonalnummer.Name := 'xdsMitteilungenMSGBoardIDFromPersonalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer';
    xdsMitteilungenMSGBoardIDID.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDID.Name := 'xdsMitteilungenMSGBoardIDID';
    xdsMitteilungenMSGBoardIDID.FieldName := 'MSGBoardID.ID';
    xdsMitteilungenMSGBoardIDID.Size := 38;
    xdsMitteilungenMSGBoardIDDatum.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDDatum.Name := 'xdsMitteilungenMSGBoardIDDatum';
    xdsMitteilungenMSGBoardIDDatum.FieldName := 'MSGBoardID.Datum';
    xdsMitteilungenMSGBoardIDFromNachname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromNachname.Name := 'xdsMitteilungenMSGBoardIDFromNachname';
    xdsMitteilungenMSGBoardIDFromNachname.FieldName := 'MSGBoardID.FromNachname';
    xdsMitteilungenMSGBoardIDFromNachname.Size := 40;
    xdsMitteilungenMSGBoardIDFromVorname.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromVorname.Name := 'xdsMitteilungenMSGBoardIDFromVorname';
    xdsMitteilungenMSGBoardIDFromVorname.FieldName := 'MSGBoardID.FromVorname';
    xdsMitteilungenMSGBoardIDFromVorname.Size := 40;
    xdsMitteilungenMSGBoardIDBetreff.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDBetreff.Name := 'xdsMitteilungenMSGBoardIDBetreff';
    xdsMitteilungenMSGBoardIDBetreff.FieldName := 'MSGBoardID.Betreff';
    xdsMitteilungenMSGBoardIDBetreff.Size := 255;
    xdsMitteilungenMSGBoardIDNotiz.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDNotiz.Name := 'xdsMitteilungenMSGBoardIDNotiz';
    xdsMitteilungenMSGBoardIDNotiz.FieldName := 'MSGBoardID.Notiz';
    xdsMitteilungenMSGBoardIDNotiz.Size := 255;
    xdsMitteilungenToPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenToPersonalnummerPersonalnummer.Name := 'xdsMitteilungenToPersonalnummerPersonalnummer';
    xdsMitteilungenToPersonalnummerPersonalnummer.FieldName := 'ToPersonalnummer.Personalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.Name := 'xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer';
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.FieldName := 'MSGBoardID.FromPersonalnummer.Personalnummer';
    xdsMitteilungenMSGBoardIDUrsprung.SetParentComponent(xdsMitteilungen);
    xdsMitteilungenMSGBoardIDUrsprung.Name := 'xdsMitteilungenMSGBoardIDUrsprung';
    xdsMitteilungenMSGBoardIDUrsprung.FieldName := 'MSGBoardID.Ursprung';
    xdsMitteilungenMSGBoardIDUrsprung.Size := 38;
  finally
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnGesendete.AfterLoadDFMValues;
    btnErhaltene.AfterLoadDFMValues;
    btnNeueMitteilung.AfterLoadDFMValues;
    btnErhalteneUngefiltert.AfterLoadDFMValues;
    xdsMitteilungen.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardID.AfterLoadDFMValues;
    xdsMitteilungenToPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardSubID.AfterLoadDFMValues;
    xdsMitteilungenToNachname.AfterLoadDFMValues;
    xdsMitteilungenToVorname.AfterLoadDFMValues;
    xdsMitteilungenDatumGelesen.AfterLoadDFMValues;
    xdsMitteilungenDatumErledigt.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDID.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDDatum.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromNachname.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromVorname.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDBetreff.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDNotiz.AfterLoadDFMValues;
    xdsMitteilungenToPersonalnummerPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDFromPersonalnummerPersonalnummer.AfterLoadDFMValues;
    xdsMitteilungenMSGBoardIDUrsprung.AfterLoadDFMValues;
  end;
end;

end.